
import React, { useEffect, useState } from 'react'
import styled from "styled-components";
import { RewardContent,RewardBox, Ctitle, DescIcon, IconClose } from './style'
import FloatLayout from "@/components/float-layout";
import moment from 'moment'
import bgd from '../imgs/19@2x.png'
import bridge from '@/config/JSbridge'
import bwmodel from '@/config/bwmodel';
import { handleUploadTrace } from '@/utils';

import {
	fetchAwardList
} from '../api'

import { Modal } from 'antd-mobile'

const isStorm = bwmodel.app === 'storm';

const Desc = ({activityId,token}) => {
	const [descVisible, setDescVisible] = useState(false);
	const [awards, setAwards] = useState([]);
	const [visible, setVisible] = useState(false);
	const [lastReward, setLastReward] = useState({})
	// const [weekList, setWeekList] = useState([{}]);

	useEffect(( ) => {
		const params = {
			"activityId": 130,
			"pageNo": 1,
			"pageSize": 10,
			"termType": "COMPLEX_RANKING_MON"
		}
		fetchAwardList(params)
			.then(res => {
				setAwards(res);

				// 设置这周的弹框 
				showLastReward(res[0].termAwardDetailList)

				// console.log(res);
			})
			.catch(err => {
				console.log(err);
			})
	}, [])


	function showLastReward(rewards ) {
		rewards = rewards || [];
		let rewardsId130 = localStorage.getItem('rewardsId130');
		if(!rewardsId130 || rewardsId130 === "null" || rewardsId130 === "undefined") {
			rewardsId130 = "{}"
		}

		const reward =	JSON.parse(rewardsId130);
		const result = rewards.find(it => {
			if(reward.id) {
				return it.id !== reward.id && it.id > reward.id
			} else {
				return it.id !== reward.id
			}
		}) || {};

	
		if(result.id) {
			setVisible(true)
			setLastReward(result);
			localStorage.setItem('rewardsId130', JSON.stringify(result));
		}
	}
	const handleLogin = () => {
		if(!isStorm) {
			window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
		}
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }

	const showModal = async () => {
		
		if(!token)  {
			return handleLogin();
			// return Toast.info('请先登录')
		}
		setDescVisible(true)
	}

	const activityShare = () => {
		const ext = JSON.parse(lastReward.ext);
		setVisible(false);
		handleUploadTrace('Millions_Winning_Sharing', 'click')

		

    if(token) {
      let sendData = {
        event: 'postForumSubsidyActivity',
        params: {
          // action: 'essayData',
          userAvatar: `${ext.avatar}`,
					userName: ext.nickname,
					rankDesc:  `风云创作收入榜第${ext.rank}名` ,
					reward: lastReward.awardType  === 12 ? `得到了${lastReward.awardNum}元现金奖励`:'风云周边(四选一)',
          url: `${process.env.REACT_APP_DEMAND_URL}active_130`, // 二维码
          
        }
      }
			
      bridge.callHandler('nativeEvent', sendData, res => {
        console.log(res);
      })
    } 
    
  }


	return (
		<React.Fragment>
			<DescIcon
				src={require('../imgs/title.png')}
				onClick={() => {
					handleUploadTrace('Million_Reward_Click','click')
					showModal()
					}} >
					我<br/>的<br/>奖<br/>励
				</DescIcon>
			<Modal 
				visible={descVisible} 
				wrapClassName="rw-desc-modal-outer" className={'lx-desc-modal long-modal'} 
				transparent onClose={() => setDescVisible(false)}>
				<Ctitle>
						<div >我的奖励</div>
					</Ctitle>
					<IconClose onClick={() => setDescVisible(false)} />
						 <RewardContent >
						<div className='title'>&nbsp;</div>
						{
							awards.map((it) => {
								return <div>
									<div> {moment(it.startTime).format('YYYY.MM.DD')}-{moment(it.endTime).format('YYYY.MM.DD')}</div>
										{
											it.termAwardDetailList && it.termAwardDetailList.map(item => {
												return (<RewardBox>
													<div className='title3'>我的月榜奖励</div>

													{
														item.awardType === 12 &&(	<div className='footer'>获得 <span><span className='money'>{item.awardNum}</span>元现金</span></div>)
													}

													{
														item.awardType !== 12 && (	<div className='footer'>风云周边（四选一）</div>)
													}
												</RewardBox>
												)
											})
										}
										{
										 	(!it.termAwardDetailList ||it.termAwardDetailList.length === 0)  && <div style={{lineHeight: '60px',textAlign: 'center'}}>
											< img style={{width: '39.6vw',margin: '60px'}}  src={require('../imgs/zanwujiangli.png')} alt=''></img>
											</div>
										}
										
								</div>
							})
						}
						
						{
							awards.length === 0  && <div style={{lineHeight: '60px',textAlign: 'center'}}>
								< img style={{width: '39.6vw',margin: '60px'}}  src={require('../imgs/zanwujiangli.png')} alt=''></img>
								</div>
						}
						
					</RewardContent> 
			</Modal>
			<div>
			<FloatLayout
					content={
						<ModalEntrance className="float-table-wrap">
							<div className='content'>
								{lastReward.awardType === 12  && <img src={require('../imgs/money.png')} alt="" />} 
								{lastReward.awardType !== 12  && <img src={require('../imgs/reward2.png')} alt="" />} 
								{/* <img src={require('../imgs/reward2.png')} alt="" /> */}
								<h1> {
									lastReward.awardType === 12 ? `${lastReward.awardNum}元现金`: '风云周边(四选一)'
									}</h1>
								<h3>奖励查看入口：</h3>
								<p>活动首页-右上角-我的奖励查看</p>
								<h3>奖励领取方式：</h3>
								<p>活动首页-右上角-活动规则-奖励发放</p>
							</div>
							<div className='btn' onClick={()=> activityShare()}>
							分享喜悦
							</div>
						</ModalEntrance>
					}
					visible={visible}
					onOverlayClick={() => {
						console.log('loading');
						setVisible(false)
					}}
				/>
			</div>
		</React.Fragment>
	)
}
export default Desc;

export const ModalEntrance= styled.div`
	height: 90vh;
	.content {
		width: 88.8vw;
		height: 125vw;
		background-image: url(${bgd});
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center center;
		margin:auto;
		padding-top: 37vw;
		padding-left: 3vw;
		padding-right: 3vw;
		box-sizing: border-box;
		img {
			height: 33.8vw;
			display: block;
			margin:auto;
		}
		h1 {
			font-weight: 800;
			font-size: 40px;
			color: #626162;
			line-height: 1.1;
			text-align:center;
			color: #FB5A00;
		}
		h3 {
			font-family: Alibaba PuHuiTi;
			font-weight: 800;
			font-size: 18px;
			color: #626162;
			line-height: 1.2px;
		}
		p {
			font-family: Alibaba PuHuiTi;
			font-weight: 400;
			font-size: 16px;
			color: #626162;
			line-height: 1;
		}
	}
	.btn {
		width: 155px;
		height: 46px;
		background: linear-gradient(181deg, #FF9B00 0%, #FF6D00 100%);
		// width: 202px;
		// height: 46px;
		font-family: Alibaba PuHuiTi;
		font-weight: 800;
		font-size: 24px;
		color: #FFFFFF;
		line-height: 46px;
		border-radius: 23px;
		text-align: center;
		margin:20px auto;
	}
		
	// #FF9B00 #FF6D00
`





// WEBPACK FOOTER //
// ./src/views/activity_130/components/reward.js